import { useEffect, useRef } from 'react';
import { useAppState } from '../../state';

export default function AudioTrack({ track }: { track: any }) {
  const { activeSinkId } = useAppState();
  const audioEl = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const el = audioEl.current;
    if (!el || !track) return;
    if (typeof track.play === 'function') {
      track.play(el);
    } else if (typeof track.attach === 'function') {
      el.appendChild(track.attach());
    }
    return () => {
      if (typeof track.stop === 'function') track.stop();
      else if (typeof track.close === 'function') track.close();
      el.srcObject = null;
    };
  }, [track]);

  useEffect(() => {
    audioEl.current?.setSinkId?.(activeSinkId);
  }, [activeSinkId]);

  return <audio ref={audioEl} autoPlay playsInline style={{ display: 'none' }} />;
}
